import {
  makeProviderKey,
  type IntegrationProvider,
} from '@littlebird/integrations';
import { MEETING_NOTE_SOURCES, type MeetingNoteSource } from '@littlebird/sdk';

/** The note-taking app a connected remote MCP provider is, when the backend syncs its notes */
export function meetingNoteSourceForProvider(
  provider: IntegrationProvider
): MeetingNoteSource | undefined {
  return MEETING_NOTE_SOURCES.find(
    (source) => makeProviderKey('mcp', source.slug) === provider.key
  );
}
